import styled from 'vue-styled-components';

export const ScheduleItemContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const ScheduleItemWrapper = styled('div', { isActive: Boolean })`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 2px;
    border: 1px solid ${(props) => (props.isActive ? '#0E74F5' : '#E2E7EB')};
    background: #fff;
    height: 40px;
    padding: 0 12px 0 18px;

    color: #a6a6a6;
    text-align: center;
    font-family: var(--font-family-primary);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21.333px; /* 133.333% */

    cursor: pointer;
    user-select: none;

    svg {
        fill: #000;
    }
`;

export const TimeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TimeText = styled.span`
    text-align: center;
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #3c464f;
`;

export const TimePickerWrapper = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 8px;
    display: flex;
    width: 280px;
    flex-direction: column;
    z-index: 1000;
    user-select: none;

    border-radius: var(--Radius-150, 12px);
    border: 1px solid var(--color-gray-30);
    background: var(--color-gray-white);

    /* Depth4/Shadow1 */
    box-shadow: 0px 4px 16px 0px rgba(60, 70, 79, 0.12);
`;

export const TimeSeparatorDot = styled.div`
    display: flex;
    width: 6px;
    height: 6px;
    flex-shrink: 0;
    border-radius: 1000px;
    background: var(--color-gray-80);
`;

export const TimeSeparatorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
    height: 60px;
    align-self: flex-end;
    justify-content: center;
`;

export const TimeInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 16px 16px 16px;
`;

export const TimePickerColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const TimezoneText = styled.div`
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #6e767d;
`;

export const PlaceholderText = styled.div`
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #949aa1;
`;

export const TimePickerInputWrapper = styled('div', { isError: Boolean })`
    input {
        color: var(--color-gray-100);
        text-align: center;

        /* Body/2XL500 - 22 */
        font-family: var(--font-family-primary);
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 30px; /* 136.364% */
        letter-spacing: -0.11px;

        border-radius: 10px;
        border: 1px solid
            ${(props) =>
                props.isError ? 'var(--color-red-50)' : 'var(--color-gray-30)'};
        background: ${(props) =>
            props.isError ? 'var(--color-red-5)' : 'var(--color-gray-white)'};

        width: 100%;
        height: 60px;

        &:focus {
            outline: none;
            border: 1px solid
                ${(props) =>
                    props.isError
                        ? 'var(--color-red-50)'
                        : 'var(--color-blue-60)'};
            background: ${(props) =>
                props.isError
                    ? 'var(--color-red-5)'
                    : 'var(--color-gray-white)'};

            /* Foucs shadow */
            box-shadow: 0px 0px 0px
                ${(props) =>
                    props.isError
                        ? '2px rgba(250, 69, 73, 0.20)'
                        : '4px rgba(44, 141, 255, 0.2)'};
        }

        &::placeholder {
            color: var(--color-gray-70);
        }
    }
`;

export const TimePickerFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px;
    border-top: 1px solid var(--color-gray-30);
`;

export const Button = styled('button', { primary: Boolean })`
    display: inline-flex;
    height: var(--Space-40, 40px);
    min-width: 64px;
    padding: var(--Space-0, 0px) var(--Space-10, 10px);
    justify-content: center;
    align-items: center;
    gap: var(--Space-2, 2px);
    flex-shrink: 0;
    border-radius: var(--Radius-100, 8px);
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.16px;
    font-family: var(--font-family-primary);
    cursor: pointer;

    ${(props) =>
        props.primary
            ? `
        background: var(--color-blue-50);
        color: var(--color-gray-white);
        border: none;
        font-weight: 500;

        &:hover {
            background: var(--color-blue-60);
            color: var(--color-blue-5);
        }

        &:active {
            background: var(--color-blue-70);
            color: var(--color-blue-5);
        }

        &:disabled {
            background: var(--color-blue-20);
            color: var(--color-gray-white);
            cursor: not-allowed;
        }
    `
            : `
        border: 1px solid var(--color-gray-40);
        background: var(--color-gray-white);
        color: var(--color-gray-100);
        font-weight: 400;

        &:hover {
            border: 1px solid var(--color-gray-50);
            background: var(--color-gray-10);
            color: var(--color-gray-110);
        }

        &:active {
            border: 1px solid var(--color-gray-50);
            background: var(--color-gray-20);
            color: var(--color-gray-110);
        }
    `}
`;

export const TimePickerHeader = styled.div`
    padding: 16px;
`;

export const TimePickerTitle = styled.h4`
    color: var(--color-gray-120);
    font-family: var(--font-family-primary);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.08px;
    margin: 0;
`;

export const TimePickerInputLabel = styled.label`
    color: var(--color-gray-80);
    font-family: var(--font-family-primary);
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.2px;
`;

export const ErrorMessage = styled.div`
    color: #ff4d4f;
    font-size: 12px;
    margin-top: 4px;
    padding-left: 4px;
`;
